import { render, staticRenderFns } from "./tickets-documents.vue?vue&type=template&id=50f34e6c"
import script from "./tickets-documents.vue?vue&type=script&lang=js"
export * from "./tickets-documents.vue?vue&type=script&lang=js"
import style0 from "./tickets-documents.vue?vue&type=style&index=0&id=50f34e6c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports